import axios from "axios";
import { debounce, findIndex, isEqual, throttle } from "lodash";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import Dropzone from "react-dropzone";
import { batch, connect } from "react-redux";
import Format from "string-format";
import { ReactComponent as TldrPointer } from "../assets/icons/pointer.svg";
import {
  fetchAllFonts,
  fetchFonts,
  fetchStoryFonts,
  resetFonts,
} from "../_actions/appActions";
import { checkAssetStatus } from "../_actions/assetAction";
import { switchWorkspace, syncWorkspaces } from "../_actions/authActions";
import { fetchBrandKits } from "../_actions/brandKitActions";
import {
  hideCommandKSearch,
  showCommandKSearch,
} from "../_actions/commandKActions";
import {
  SHARED_ITEM_USER_ENDPOINT,
  WEBSOCKETS_ENDPOINT,
} from "../_actions/endpoints";
import {
  closeSlider,
  openAdvancedSettings,
  openSlider,
} from "../_actions/sidebarSliderActions";
import {
  fetchCommentsCount,
  fetchStoryDetail,
  fetchStoryPages,
  setCounter,
  updateStoryMusic,
  uploadFile,
  uploadFontFile,
  uploadImageAndAddLayer,
} from "../_actions/storiesActions";
import {
  setActiveLayer,
  setActivePage,
  setClonedItems,
  setCrop,
  setElementFormat,
  setGroupSelection,
  setVideoPlayingStatus,
} from "../_actions/textToolbarActions";
import { GlobalHotKeys } from "react-hotkeys";
import { ImageAppSources } from "../_actions/types";
import {
  wsAddLayer,
  wsAddMusic,
  wsAddPage,
  wsBroadcast,
  wsCloneLayers,
  wsClonePage,
  wsConnect,
  wsCopyFromTemplate,
  wsDeleteLayers,
  wsDeletePage,
  wsDisconnect,
  wsGroup,
  wsMoveLayer,
  wsRedo,
  wsSetAsBackground,
  wsUndo,
  wsUnGroup,
  wsUpdateLayer,
  wsUpdateLayers,
  wsUpdateMusic,
  wsUpdatePage,
} from "../_actions/webSocketAction";
import {
  CROP_INTERACTION,
  defaultMusicPayload,
  defaultOption,
} from "../_components/canvas/constants/defaults";
import ArtBoardHandler from "../_components/common/artBoardHandlers/ArtBoardHandler";
import {
  Dropable,
  ShowCenterSpinner,
  TldrBasicConfirmationModal,
} from "../_components/common/statelessView";
import TldrCommandK from "../_components/common/tldrCommandK/TldrCommandK";
import TldrContextMenu from "../_components/common/TldrContextMenu";
import {
  ACTIVE_SELECTION,
  ADVANCED_AI_EDITOR_PANEL,
  ADVANCED_EDITOR_EDIT,
  ADVANCED_EDITOR_PANEL,
  ASSETS_SLIDER_PANEL,
  comboKey1,
  EDITOR_BOTTOM_MENU,
  EDITOR_SIDEBAR_MENU,
  FABRIC_TEXT_TYPES,
  FONT_BOLD_WEIGHT,
  FONT_REGULAR_WEIGHT,
  FONTS_SLIDER_PANEL,
  ICONS_SLIDER_PANEL,
  IMAGE_URL_SUFFIXES,
  IMAGES_SLIDER_PANEL,
  MUSIC_URL_SUFFIXES,
  PASTED_URL_SUFFIXES,
  REMOTE_COLLOBORATION_BROADCAST_MOUSE_POINTER,
  RIGHT_SIDEBAR_QUERIES,
  TEXT_SLIDER_PANEL,
  LAYER_ORDER_BRING_TO_FRONT,
  LAYER_ORDER_BRING_FORWARD,
  LAYER_ORDER_SEND_BACKWARD,
  LAYER_ORDER_SEND_TO_BACK,
} from "../_components/details/constants";
import StudioEditorToolbar from "../_components/details/editorToolbar/commonEditorToolbar/StudioEditorToolbar";
import StudioSidebarItemDetailSlider from "../_components/details/sidebarPanels/StudioSidebarItemDetailSlider";
import StudioNavbar from "../_components/details/StudioNavbar";
import StudioRightSidePanel from "../_components/details/StudioRightSidePanel";
import {
  StyledLoaderSlide,
  StyledPointer,
  StyledUserLabel,
} from "../_components/styled/details/stylesDetails";
import { wsStatusMessage } from "../_middleware/middleware";
import {
  checkArtboardLimit,
  endsWithAny,
  genericImageDownload,
  getAuthToken,
  getMediaDurationFromFile,
  getMIMETypeFromFabricObject,
  isURL,
} from "../_utils/common";
import {
  ASSET_MAX_FILE_UPLOAD_SIZE,
  ASSETS_ALLOWED_FILE_EXTENSIONS,
  BottomPanelState,
  BottomPanelViewTypes,
  DEFAULT_ARTBOARD_DURATION,
  EXPORT_IMAGE_ERROR_PAYLOAD,
  StoryTypes,
  UpdateSourceTypes,
} from "../_utils/constants";
import { ACCESS_DENIED } from "../_utils/routes";
import "./../_utils/simplifiedFabric";
import ArtBoard from "./ArtBoard";
import ArtBoardFooter from "./ArtBoardFooter";
import Sidebar from "../_components/home/Sidebar";
import { SidebarStyleComponent, StyledTabbar } from "./StoryDetailsPageStyles";
import { fabric } from "fabric";
import StorySidebarFooter from "../_components/story/StorySidebarFooter";
import Tabbar from "./Tabbar";
import TldrMediaTrimmingModal from "../_components/common/TldrMediaTrimmingModal";
import { FloatingButton } from "../TldrApp/TldrHomeBaseStyles";
import { TabbarWrapper } from "../_components/styled/styles";
import {
  black,
  headerHeight,
  secondaryColor,
} from "../_components/styled/variable";
import { TimelineProvider } from "../_utils/timeline";
import {
  closeBottomPanel,
  openBottomPanel,
} from "../_actions/bottomPanelActions";
import { getSubscription } from "../_actions/subscriptionActions";
import { setRBStoryPermissionCheck } from "../_actions/permissionActions";
import isEmpty from "../_validation/is-empty";
import { FaPlus, FaTimes } from "react-icons/fa";
import { showToast } from "../_utils/showToast";
import { Box, Flex, Icon } from "@chakra-ui/react";
import { onRejectFileDropzone } from "../_utils/mimeType";
import { withTranslation } from "react-i18next";
import VariableFont from "../_utils/variableFont";
import FontHandler from "../_components/canvas/handlers/FontHandler";
import * as keyCode from "../_components/canvas/constants/codes";
import { editorKeyMap } from "../_components/canvas/handlers/ShortcutHandler";
import { openUrl } from "@simplified-workspace/shared/util";

const format = require("string-format");
const opentype = require("opentype.js");

export class StoryDetailsPage extends Component {
  signal = axios.CancelToken.source();

  constructor(props) {
    super(props);

    this.state = {
      pageArea: {
        height: 576,
        width: 1024,
      },

      zoomRatio: 1,
      editing: false,
      selectedItem: null, // What is the goal of this
      showComment: false,
      mediaTrimmingData: {
        show: false,
        data: null,
        maxTrim: null,
      },
      showBottomMenu: true,
      isExtendedDrawerShowing: false,
      fontUploadData: {
        showConsentPopup: false,
        uploadingCount: 0,
        droppedFile: null,
      },
    };

    this.pageAreaRef = React.createRef();
    this.editorAreaRef = React.createRef();
    this.canvasRef = React.createRef();
    this.droppableRef = React.createRef();
    this.trackMousePointer = this.trackMousePointer.bind(this);
    this.thorttledTrackMousePointer = throttle(this.trackMousePointer, 300);
    this.timers = [];
    this.isCut = false;
  }

  componentDidUpdate = (prevProps) => {
    if (
      prevProps.sidebarSlider.isSliderOpen === "open" &&
      this.props.sidebarSlider.isSliderOpen === "close"
    ) {
      if (
        prevProps.sidebarSlider.sliderPanelType === "videos" &&
        prevProps.bottomPanel.viewState === "close"
      ) {
        this.props.openBottomPanel();
      }
      this.setState({ showBottomMenu: true });
    }
  };

  isItemActive = (item) => {
    if (!item?.extraData?.panel) {
      return;
    }
    return this.isActivePanel(item?.extraData?.tabs);
  };

  isActivePanel = (tabs) => {
    const { sliderPanelType, isSliderOpen } = this.props.sidebarSlider;

    return tabs.includes(sliderPanelType) && isSliderOpen === "open"
      ? " active"
      : "";
  };

  openPanel = (panel) => {
    if (!this.isActivePanel(panel)) {
      this.props.openSlider(panel);
    } else {
      this.props.closeSlider();
    }
  };

  openRightPanel = (panel) => {
    if (!this.isActivePanel(panel)) {
      this.props.openAdvancedSettings(panel);
    } else {
      this.props.closeSlider();
    }
  };

  sidebarHeader = "";
  sidebarFooter = (<StorySidebarFooter />);

  onExtendedDrawerStateChange = (state) => {
    this.setState(() => {
      return { isExtendedDrawerShowing: state };
    });
  };

  render() {
    const {
      params: { designId, org },
    } = this.props.match;
    const workspaceId = Number(org);
    const {
      pagestore,
      story,
      sidebarSlider,
      rightsidebar,
      bottomPanel,
      editor,
      t,
    } = this.props;
    const { activeElement, activePage, activeSelection } = editor;
    const { loaded, pageIds } = pagestore;
    const { payload } = story;
    const { isSliderOpen } = sidebarSlider;
    const { viewState, viewType: bottomPanelViewType } = bottomPanel;
    const isBottomPanelOpen = viewState === BottomPanelState.OPEN;
    const { isActionPanelOpen } = rightsidebar;
    const isEmpty = pageIds.length === 0;

    let artboardHeight = payload.image_height ? payload.image_height : 1080;
    let artboardWidth = payload.image_width ? payload.image_width : 1080;

    let artboardSize = this.getArtBoardSize(artboardHeight, artboardWidth);

    // let loaded = false;

    const { zoomRatio, mediaTrimmingData, fontUploadData } = this.state;

    const miniToolbarHidden =
      !(activeElement.id || activePage.isSelected || activeSelection.mime) ||
      bottomPanelViewType === BottomPanelViewTypes.ARTBOARDS_GRID_VIEW ||
      isActionPanelOpen;

    const artboardBottomBar =
      !isBottomPanelOpen && !isActionPanelOpen && !activeElement.mime;

    const {
      onAdd,
      onRemove,
      onSelect,
      onModified,
      onModifiedNoDebounce,
      onChange,
      onZoom,
      onTooltip,
      onClick,
      onContext,
      onTransaction,
      onActiveLayer,
      onTextFormatingChange,
      onTextSelectionChange,
      onVideoPlayingStatusChange,
      onCopy,
      onPaste,
      onSelectTopLayer,
      onSelectBottomLayer,
      onUndo,
      onRedo,
      onGroup,
      onUngroup,
      onClone,
      onExportAsJPEG,
      onPrevArtboardSelection,
      onNextArtboardSelection,
      onGrabModeEnable,
      onGrabModeDisable,
      onSelectAllLayers,
      onCut,
    } = this.canvasHandlers;

    const hotkeysHandler = {
      OPEN_GLOBAL_SEARCH: (e) => this.onHotkeysToggleGlobalSearch(e),
      UNDO: (e) => this.onHotkeysUndo(e),
      REDO: (e) => this.onHotkeysRedo(e),
      EXPORT_AS_JPEG: (e) => this.onHotkeysExportAsJPEG(e),
      OPEN_TEXT_PANEL: (e) =>
        this.onHotkeysOpenSidebarPanel(e, TEXT_SLIDER_PANEL),
      OPEN_ASSETS_PANEL: (e) =>
        this.onHotkeysOpenSidebarPanel(e, ASSETS_SLIDER_PANEL),
      OPEN_VISUALS_PANEL: (e) =>
        this.onHotkeysOpenSidebarPanel(e, ICONS_SLIDER_PANEL),
      OPEN_MEDIA_PANEL: (e) =>
        this.onHotkeysOpenSidebarPanel(e, IMAGES_SLIDER_PANEL),
      OPEN_HOTKEYS_PANEL: (e) => this.onHotkeysOpenSidebarPanel(e),
      CLOSE_PANEL: (e) => this.onHotkeysCloseSidebarPanel(e),
      ZOOM_IN: (e) => this.onHotkeysZoomIn(e),
      ZOOM_OUT: (e) => this.onHotkeysZoomOut(e),
      ZOOM_ONE_TO_ONE: (e) => this.onHotkeysZoomOneToOne(e),
      ZOOM_TO_FIT: (e) => this.onHotkeysZoomToFit(e),
      GRAB_MODE: (e) => this.onHotkeysGrabModeEnable(e),
      SELECTION_MODE: (e) => this.onHotkeysGrabModeDisable(e),
      CLONE: (e) => this.onHotkeysClone(e),
      DELETE: (e) => this.onHotkeysDelete(e),
      MOVE_LAYER_ONE_UNIT: (e) => this.onHotkeysMoveLayerOneUnit(e),
      MOVE_LAYER_TEN_UNITS: (e) => this.onHotkeysMoveLayerTenUnits(e),
      MOVE_LAYER_HUNDRED_UNITS: (e) => this.onHotkeysMoveLayerHundredUnits(e),
      ARTBOARD_PREV: (e) => this.onHotkeysPrevArtboardSelection(e),
      ARTBOARD_NEXT: (e) => this.onHotkeysNextArtboardSelection(e),
      COPY: (e) => this.onHotkeysCopy(e),
      PASTE: (e) => this.onHotkeysPaste(e),
      LOCK: (e) => this.onHotkeysLockLayer(e),
      GROUP: (e) => this.onHotkeysGroup(e),
      UNGROUP: (e) => this.onHotkeysUngroup(e),
      SELECT_TOP_LAYER: (e) => this.onHotkeysSelectTopLayer(e),
      SELECT_BOTTOM_LAYER: (e) => this.onHotkeysSelectBottomLayer(e),
      BOLD: (e) => this.onHotkeysBold(e),
      ITALIC: (e) => this.onHotkeysItalic(e),
      UNDERLINE: (e) => this.onHotkeysUnderline(e),
      STRIKETHROUGH: (e) => this.onHotkeysStrikethrough(e),
      SELECT_ALL_LAYERS: (e) => this.onHotkeysSelectAllLayers(e),
      CUT: (e) => this.onHotkeysCut(e),
      BRING_TO_FRONT: (e) =>
        this.onHotkeysLayerOrderChange(e, LAYER_ORDER_BRING_TO_FRONT),
      BRING_FORWARD: (e) =>
        this.onHotkeysLayerOrderChange(e, LAYER_ORDER_BRING_FORWARD),
      SEND_BACKWARD: (e) =>
        this.onHotkeysLayerOrderChange(e, LAYER_ORDER_SEND_BACKWARD),
      SEND_TO_BACK: (e) =>
        this.onHotkeysLayerOrderChange(e, LAYER_ORDER_SEND_TO_BACK),
    };

    return (
      <DndProvider backend={HTML5Backend}>
        <TimelineProvider canvasRef={this.canvasRef}>
          <GlobalHotKeys keyMap={editorKeyMap} handlers={hotkeysHandler} />
          <Box
            h={["100vh", "100vh", "100vh", ""]}
            w={["100vw", "100vw", "100vw", ""]}
            overflow={["hidden", "hidden", "hidden", "auto"]} //fixes overflow in mobile app
          >
            <StudioNavbar
              storyId={designId}
              org={workspaceId}
              canvasRef={this.canvasRef}
              onExtendedDrawerStateChange={this.onExtendedDrawerStateChange}
            />

            <StudioSidebarItemDetailSlider
              canvasRef={this.canvasRef}
              artBoardHandler={this.artBoardHandler}
            />
            <Flex
              overflow={"hidden"}
              h={`calc(100% - ${headerHeight})`}
              mt={{ xs: "-1.5rem", sm: "-1.5rem", md: "0", lg: "0" }}
            >
              <Box display={["none", "none", "block", "block"]}>
                <Sidebar
                  collapsed={true}
                  menu={EDITOR_SIDEBAR_MENU}
                  header={this.sidebarHeader}
                  footer={this.sidebarFooter}
                  onItemClick={this.onMenuItemClick}
                  isItemActive={this.isItemActive}
                  styles={SidebarStyleComponent}
                />
              </Box>

              <div className="tldr-editor" ref={this.editorAreaRef}>
                {loaded && pageIds.length > 0 ? (
                  <>
                    {!this.props.isMobileView && (
                      <div className="tldr-editor-header-toolbar">
                        <StudioEditorToolbar
                          onSelect={onSelect}
                          canvasRef={this.canvasRef}
                          artBoardHandler={this.artBoardHandler}
                        />
                      </div>
                    )}
                    <div
                      onMouseMove={this.onSliderContainerMouseMove}
                      className="tldr-editor-canvas-container"
                      ref={(node) => {
                        if (!node) return;
                        this.pageAreaRef = node;
                      }}
                    >
                      <Dropable
                        droppableRef={this.droppableRef}
                        onDrop={this.onDrop}
                        // ref={this.container}
                        className="tldr-editor-canvas"
                      >
                        <Dropzone
                          onDrop={(acceptedFiles) => this.upload(acceptedFiles)}
                          noClick={true}
                          maxSize={ASSET_MAX_FILE_UPLOAD_SIZE}
                          onDropRejected={(rf) => onRejectFileDropzone(rf, t)}
                          accept={ASSETS_ALLOWED_FILE_EXTENSIONS}
                        >
                          {({ getRootProps, getInputProps }) => (
                            <div {...getRootProps()}>
                              <input {...getInputProps()} />

                              <ArtBoard
                                storyId={designId}
                                ref={(c) => {
                                  if (!c) return;
                                  this.canvasRef = c;
                                }}
                                minZoom={5}
                                maxZoom={500}
                                onModified={onModified}
                                onModifiedNoDebounce={onModifiedNoDebounce}
                                onAdd={onAdd}
                                onActiveLayer={onActiveLayer}
                                onRemove={onRemove}
                                onSelect={onSelect}
                                onZoom={onZoom}
                                onTooltip={onTooltip}
                                onChange={onChange}
                                onClick={onClick}
                                onContext={onContext}
                                onTransaction={onTransaction}
                                onTextFormatingChange={onTextFormatingChange}
                                onTextSelectionChange={onTextSelectionChange}
                                onVideoPlayingStatusChange={
                                  onVideoPlayingStatusChange
                                }
                                onCopy={onCopy}
                                onPaste={onPaste}
                                onSelectTopLayer={onSelectTopLayer}
                                onSelectBottomLayer={onSelectBottomLayer}
                                onUndo={onUndo}
                                onRedo={onRedo}
                                onGroup={onGroup}
                                onUngroup={onUngroup}
                                onClone={onClone}
                                onExportAsJPEG={onExportAsJPEG}
                                onPrevArtboardSelection={
                                  onPrevArtboardSelection
                                }
                                onNextArtboardSelection={
                                  onNextArtboardSelection
                                }
                                onGrabModeEnable={onGrabModeEnable}
                                onGrabModeDisable={onGrabModeDisable}
                                onSelectAllLayers={onSelectAllLayers}
                                onCut={onCut}
                                keyEvent={{
                                  transaction: true,
                                }}
                                objectOption={defaultOption}
                                artBoardHandler={this.artBoardHandler}
                                droppableRef={this.droppableRef}
                              />
                            </div>
                          )}
                        </Dropzone>

                        {this.showRemoteMousePointers()}
                      </Dropable>
                      {this.state.showBottomMenu && (
                        <ArtBoardFooter
                          isActionPanelOpen={isActionPanelOpen}
                          isSliderOpen={isSliderOpen === "open"}
                          isBottomPanelOpen={isBottomPanelOpen}
                          canvasRef={this.canvasRef}
                          zoomRatio={zoomRatio}
                          story={story}
                          bottomPanelViewType={bottomPanelViewType}
                        />
                      )}
                      <Box
                        className="o-hidden"
                        display={["block", "block", "none", "none"]}
                      >
                        {!this.state.showBottomMenu && (
                          <TabbarWrapper>
                            <div
                              className="cross-btn-container"
                              onClick={() => {
                                this.setState({ showBottomMenu: true }, () => {
                                  this.props.closeSlider();
                                });
                              }}
                            >
                              <div className="cross-btn">
                                <FaTimes
                                  color={secondaryColor}
                                  className={
                                    "floating-add-product-icon align-self-center"
                                  }
                                />
                              </div>
                            </div>
                            <div className="tldr-vl" />
                            {/* Tabbar needs to take all the available width */}
                            <StyledTabbar style={{ flexGrow: 1 }}>
                              <Tabbar
                                tabs={EDITOR_BOTTOM_MENU}
                                onItemClick={this.onMenuItemClick}
                                isItemActive={this.isItemActive}
                                fitContent="true"
                                minWidth="100%"
                              />
                            </StyledTabbar>
                          </TabbarWrapper>
                        )}
                      </Box>
                    </div>
                    {!this.props.isMobileView && (
                      <StudioRightSidePanel
                        artBoardHandler={this.artBoardHandler}
                        canvasRef={this.canvasRef}
                      />
                    )}
                  </>
                ) : loaded && isEmpty ? (
                  <>
                    <StyledLoaderSlide
                      onClick={this.addNewPage}
                      artboardSize={artboardSize}
                    >
                      <FaPlus />
                      Add artboard
                    </StyledLoaderSlide>
                  </>
                ) : !loaded ? (
                  <StyledLoaderSlide artboardSize={artboardSize}>
                    <ShowCenterSpinner loaded={loaded} />
                  </StyledLoaderSlide>
                ) : (
                  <></>
                )}
              </div>
            </Flex>

            {this.props.isMobileView &&
              this.state.showBottomMenu &&
              !(
                bottomPanelViewType ===
                  BottomPanelViewTypes.ARTBOARDS_GRID_VIEW || isBottomPanelOpen
              ) &&
              !isActionPanelOpen &&
              !this.state.isExtendedDrawerShowing &&
              !activeElement.mime && (
                <FloatingButton
                  style={{
                    marginTop:
                      artboardBottomBar && miniToolbarHidden
                        ? "-101px"
                        : "-144px",
                  }}
                >
                  <Flex
                    h="100%"
                    w="100%"
                    alignItems={["center", "center", "stretch", "stretch"]}
                    justifyContent={[
                      "center",
                      "center",
                      "flex-start",
                      "flex-start",
                    ]}
                    display={["flex", "flex", "none", "none"]}
                    onClick={() => {
                      this.setState({ showBottomMenu: false });
                    }}
                  >
                    <Icon
                      as={FaPlus}
                      alignSelf="center"
                      className="floating-add-product-icon "
                      color={black}
                    />
                  </Flex>
                </FloatingButton>
              )}

            <TldrCommandK canvasRef={this.canvasRef} />
            {mediaTrimmingData && mediaTrimmingData.show && (
              <TldrMediaTrimmingModal
                show={mediaTrimmingData.show}
                onHide={this.resetTrimmingData}
                onSubmit={this.onSubmitTrimMedia}
                data={mediaTrimmingData.data}
                mediaType={"Video"}
                maxTrimPercentage={mediaTrimmingData.maxTrim}
                defaultTrimPercentage={mediaTrimmingData.maxTrim}
                canvasRef={this.canvasRef}
              />
            )}

            {fontUploadData.showConsentPopup ? (
              <TldrBasicConfirmationModal
                title={t("font_conf_modal_title", { ns: "fontlist" })}
                message={t("font_conf_modal_detail", { ns: "fontlist" })}
                inProgress={fontUploadData.uploadingCount > 0}
                show={fontUploadData.showConsentPopup}
                onHide={() => {
                  this.setState({
                    ...this.state,
                    fontUploadData: {
                      ...fontUploadData,
                      showConsentPopup: false,
                      droppedFile: null,
                    },
                  });
                }}
                onYes={() => {
                  this.uploadDroppedFontFile();
                }}
              />
            ) : null}
          </Box>
        </TimelineProvider>
      </DndProvider>
    );
  }

  componentDidMount() {
    const {
      params: { designId, org },
    } = this.props.match;
    const queryPath = new URLSearchParams(this.props.location.search).get(
      "view"
    );
    const workspaceId = Number(org);

    if (this.props.auth.payload?.selectedOrg !== workspaceId) {
      this.props.syncWorkspaces().then(() => {
        const workspace = this.props.auth.payload?.orgs?.find(
          (item) => item.id === workspaceId
        );

        if (workspace) {
          this.props.switchWorkspace(workspaceId, getAuthToken());

          this.setupEditor(designId, queryPath);
        } else {
          this.props.history.push(ACCESS_DENIED);
        }
      });
    } else {
      this.setupEditor(designId, queryPath);
    }
  }

  setupEditor = (designId, queryPath) => {
    batch(() => {
      // TODO: call fetchBrandkit here and store in redux
      this.props.getSubscription();
      this.props.fetchBrandKits();

      this.props
        .fetchStoryFonts(designId, this.signal, { ...this.props })
        .then((result) => {
          const storyFonts = result?.story_fonts;
          this.waitForCanvasHandlerForFontLoading(
            this.canvasRef.handler,
            storyFonts
          );
          return this.props.fetchStoryDetail(designId, this.signal, {
            ...this.props,
          });
        })
        .then((story) => {
          this.getSharedItemOrgUser(story);
          // this.openPanel(ASSETS_SLIDER_PANEL);
          if (RIGHT_SIDEBAR_QUERIES.includes(queryPath)) {
            this.openRightPanel(queryPath);
          }

          this.props.fetchStoryPages(designId, null, this.props).then(() => {
            if (this.props.pagestore?.pageIds?.length > 0) {
              const firstPageIndex = 0;
              this.props.setActivePage(
                this.props.pagestore.pageIds[firstPageIndex],
                firstPageIndex,
                false
              );
            }
          });
        });

      const token = getAuthToken();
      if (token) {
        var dev = Format(WEBSOCKETS_ENDPOINT, designId, token);
        this.props.wsConnect(dev);
      }
    });

    // Fetch Simplified's fonts
    this.props.fetchFonts(this.props, this.signal);
    this.props.fetchAllFonts(this.props, this.signal, 1);
  };

  waitForCanvasHandlerForFontLoading = (handler, fonts) => {
    setTimeout(() => {
      if (handler) {
        this.canvasRef.handler.fontHandler.setOptions({
          clearCache: true,
        });

        this.props.brandkits.forEach((bk) => {
          if (bk.fonts.length > 0) {
            this.canvasRef.handler.fontHandler.addFonts(bk.fonts);
          }
        });
        this.canvasRef.handler.fontHandler.addFonts(fonts);
        return;
      }

      this.waitForCanvasHandlerForFontLoading(this.canvasRef.handler, fonts);
    }, 5);
  };

  componentDidUpdate(prevProps, prevState) {
    // Add google font

    if (!isEqual(this.props.fonts, prevProps.fonts)) {
      this.waitForCanvasHandlerForFontLoading(
        this.canvasRef.handler,
        this.props.fonts
      );
    }

    if (this.props.pagestore.loaded && this.canvasRef) {
      this.artBoardHandler = new ArtBoardHandler(this.canvasRef.handler);
    }
    if (
      this.props.pagestore.pageIds.length > 0 &&
      !isEqual(prevProps.pagestore.pageIds, this.props.pagestore.pageIds)
    ) {
      if (!this.props.activePage.id) {
        const {
          params: { pageId },
        } = this.props.match;
        let pageIndex = pageId ? pageId - 1 : 0;
        this.props.setActivePage(
          this.props.pagestore.pageIds[pageIndex],
          pageIndex,
          false
        );
      }
    }
    if (prevProps.activePage.id !== this.props.activePage.id) {
      this.props.fetchCommentCount(this.props.activePage.id);
    }
    // When new page get added
    if (
      this.props.pagestore.pageIds?.length > prevProps.pagestore.pageIds?.length
    ) {
      const {
        params: { designId },
      } = this.props.match;
      this.props
        .fetchStoryFonts(designId, this.props, this.signal)
        .then((data) => {
          this.canvasRef.handler.fontHandler.addFonts(data?.story_fonts);
        });
    }
  }

  addNewPage = () => {
    const { pagestore, subscription } = this.props;
    const isAvailable = checkArtboardLimit(pagestore, subscription);
    if (isAvailable) this.props.wsAddPage();
    // to close the context menu
    if (this.canvasRef.handler && this.canvasRef.handler.contextmenuHandler) {
      this.canvasRef.handler.contextmenuHandler.hide();
    }
  };

  saveHoveredItem = (hoveredItem, item) => {
    hoveredItem.set({ oldContent: null });
    this.canvasRef.handler.canvas.fire("object:modified", {
      target: hoveredItem,
      message: { content: { ...item?.content } },
    });
  };

  onDrop = async (item) => {
    const itemMeta = item?.content?.meta;
    const itemId = itemMeta?.id;

    const hoveredItem = this.canvasRef.handler.canvas
      .getObjects()
      .find((item) => !!item.oldContent);

    if (item.mime === "shape") {
      if (item.type === "icon") {
        // if (itemMeta === null) {
        //   return;
        // }
        this.props.wsAddLayer(this.props.activePage.id, item);
      } else {
        this.props.wsCopyFromTemplate(this.props.activePage.id, itemId);
      }
    } else if (item.mime === "audio") {
      this.addStoryMusic(item);
    } else if (item.mime === "video") {
      const { story: { payload: { story_type } = {} } = {} } = this.props;
      const pageDuration = this.getActivePageDuration();
      // TODO: omit `item.content.meta.duration` after full deprecation
      const videoDuration =
        item.payload?.duration ?? item.content.meta?.duration;
      if (
        story_type === StoryTypes.ANIMATED &&
        pageDuration &&
        videoDuration &&
        pageDuration < videoDuration
      ) {
        // const maxTrimPercentage = (pageDuration / videoDuration) * 100;
        // this.setState({
        //   mediaTrimmingData: {
        //     show: true,
        //     data: item,
        //     maxTrim: maxTrimPercentage,
        //   },
        // });

        if (hoveredItem) {
          this.saveHoveredItem(hoveredItem, item);
          return;
        }
        this.addToArtBoard(item);
      } else {
        if (hoveredItem) {
          this.saveHoveredItem(hoveredItem, item);
          return;
        }
        this.addToArtBoard(item);
      }
    } else if (item.content) {
      if (hoveredItem) {
        this.saveHoveredItem(hoveredItem, item);
        return;
      }
      this.addToArtBoard(item);
    } else {
      this.props.wsCopyFromTemplate(this.props.activePage.id, item);
    }
  };

  addStoryMusic = (data) => {
    const { story } = this.props;

    const payload = {
      ...data,
      action: "add",
    };
    batch(() => {
      if (story?.payload?.payload?.music) {
        this.props.wsUpdateMusic({ music: payload });
      } else {
        this.props.wsAddMusic({ music: payload });
      }
      this.props.closeSlider(); // close slider once music added
      this.props.updateStoryMusic(payload);
    });
  };

  addToArtBoard = async (item) => {
    const { t } = this.props;
    let updatedData = item;
    if (item?.content?.source === ImageAppSources.GOOGLE_DRIVE) {
      try {
        updatedData = await genericImageDownload(
          item,
          this.signal.token,
          (timer) => {
            this.timers.push(timer);
          },
          this.props
        );
      } catch (e) {
        showToast({
          description: t("errors.image_download_went_Wrong", { ns: "common" }),
          title: t("errors.went_wrong_title"),
          status: "error",
        });

        return;
      }
    }
    this.props.wsAddLayer(this.props.activePage.id, updatedData);
  };

  upload = (acceptedFiles) => {
    // @Akshay restrict file upload to only 1 and don't show open dialog
    if (acceptedFiles.length > 0) {
      this.props.setCounter(acceptedFiles.length);
    }
    acceptedFiles.forEach((file) => {
      if (file.type.includes("image") && !file.type.includes("svg")) {
        this.props.uploadImageAndAddLayer(file, { ...this.props }, this.signal);
      } else if (file.type.includes("font")) {
        this.setState({
          fontUploadData: {
            showConsentPopup: true,
            uploadingCount: this.state.fontUploadData.uploadingCount + 1,
            droppedFile: file,
          },
        });
      } else {
        this.props.uploadFile(
          file,
          { ...this.props },
          this.signal,
          this.onDrop
        );
      }
    });
  };

  uploadDroppedFontFile = () => {
    const { auth, t } = this.props;
    const { fontUploadData } = this.state;
    const file = fontUploadData.droppedFile;
    const selectedOrgId = auth.payload.selectedOrg;

    showToast({
      description: t("story.upload_asset_waiting_msg", { ns: "common" }),
      title: t("uploading_asset", { ns: "common" }),
      status: "info",
    });

    this.props.openSlider(FONTS_SLIDER_PANEL);

    const reader = new FileReader();
    reader.onabort = () => console.warn("file reading was aborted");
    reader.onerror = () => console.error("file reading has failed");
    reader.onload = (e2) => {
      try {
        let fontBuffer = e2.target.result;
        let vf = new VariableFont(opentype.parse(fontBuffer));
        this.props
          .uploadFontFile(selectedOrgId, file, vf.getMetaInformation(), null)
          .then((fontInfo) => {
            let fontHandler = new FontHandler(null);
            fontHandler.addFont(fontInfo);

            this.setState({
              ...this.state,
              fontUploadData: {
                ...fontUploadData,
                uploadingCount: fontUploadData.uploadingCount - 1,
                showConsentPopup: false,
              },
            });

            showToast({
              description: t("story.upload_success", { ns: "common" }),
              title: t("processing", { ns: "common" }),
              status: "success",
            });
          });
      } catch (err) {
        console.error(err);
        this.setState({
          ...this.state,
          fontUploadData: {
            ...fontUploadData,
            uploadingCount: 0,
            droppedFile: null,
          },
        });
      }
    };
    reader.readAsArrayBuffer(file);
  };

  handleAiAssistantSidePanelState = () => {
    const { sliderPanelType } = this.props.rightsidebar;

    if (sliderPanelType === ADVANCED_AI_EDITOR_PANEL) {
      this.props.openAdvancedSettings(
        ADVANCED_EDITOR_PANEL,
        ADVANCED_EDITOR_EDIT
      );
    }
  };

  onModifiedLayer = (target, message) => {
    if (target.id === "cropRect") {
      return;
    }
    const { activePage } = this.props;
    const { editing } = this.state;
    this.forceUpdate();
    if (!editing) {
      this.changeEditing(true);
    }
    if (target.id === "workarea") {
      const { left, top } = this.canvasRef.handler.workarea;
      const objectPayload = target.toJSON(
        this.canvasRef.handler.propertiesToInclude
      );
      objectPayload.src = target.src;
      objectPayload["left"] -= left;
      objectPayload["top"] -= top;
      let updatedMessage = {
        page: activePage.id,
        payload: objectPayload,
        content: message?.content ? { ...message?.content } : {},
      };
      this.props.wsUpdatePage(updatedMessage);
      return;
    }

    if (target.type === "activeSelection") {
      this.props.wsUpdateLayers(message, this.props.activePage.id);
    } else {
      if (target.selectable) {
        const objectPayload = target.toJSON(
          this.canvasRef.handler.propertiesToInclude
        );
        this.props.setElementFormat(objectPayload);
      } else {
        target.selectable = false;
      }

      let objectPayload = target.toJSON(
        this.canvasRef.handler.propertiesToInclude,
        this.canvasRef.handler.propertiesToExclude
      );
      this.canvasHandlers.onUpdate(target, objectPayload, message);
    }
  };

  canvasHandlers = {
    onUpdate: (target, objectPayload, extraMessage = {}) => {
      const { left, top } = this.canvasRef.handler.workarea;
      let payload = Object.assign({}, objectPayload);

      payload["left"] -= left;
      payload["top"] -= top;
      payload["id"] = target.id;
      payload.src = target.src;

      const lastUpdatedTimeStamp = Date.now();

      payload["lastUpdated"] = lastUpdatedTimeStamp;
      target.lastUpdated = lastUpdatedTimeStamp;

      var message = {
        layer: target.id,
        payload: payload,
        ...extraMessage,
      };

      this.props.wsUpdateLayer(message);
    },
    onZoom: (zoom) => {
      this.setState({
        zoomRatio: zoom,
      });
    },
    onTextSelectionChange: (target, style) => {
      this.props.setElementFormat(style);
    },
    onActiveLayer: (target) => {
      // When crop is enable and user click anywhere else then finish the crop/clip and discard current selection
      if (
        target &&
        target.id !== "cropRect" &&
        this.canvasRef.handler.interactionMode === CROP_INTERACTION
      ) {
        if (!this.canvasRef.handler.clipHandler.clipRect) {
          this.canvasRef.handler.cropHandler.finish();
        } else {
          this.canvasRef.handler.clipHandler.finish();
        }
        this.canvasRef.handler.canvas.discardActiveObject();
        this.props.setCrop(false);
      }
      if (!target) {
        // user clicks outside area
        batch(() => {
          this.props.setActiveLayer(null, null, null, null);
          this.props.setActivePage(
            this.props.activePage.id,
            this.props.activePage.pageIndex,
            true
          );
          this.handleAiAssistantSidePanelState();
        });
      } else if (target.id === "cropRect") {
        // Do nothing
      } else if (target.id === "workarea") {
        // user clicks on the artboard area
        this.props.setActivePage(
          this.props.activePage.id,
          this.props.activePage.pageIndex,
          true
        );
        this.handleAiAssistantSidePanelState();
      } else if (target.selectable) {
        // user clicks on the node
        let objectPayload = target.toJSON(
          this.canvasRef.handler.propertiesToInclude
        );
        if (
          target instanceof fabric.Textbox ||
          target instanceof fabric.IText
        ) {
          target.setSelectionStart(0);
          target.setSelectionEnd(0);
          objectPayload =
            this.canvasRef.handler.textHandler.getStyle(objectPayload);
        }
        this.handleAiAssistantSidePanelState();
        const mime = getMIMETypeFromFabricObject(objectPayload.type);
        this.props.setActiveLayer(target.id, mime, objectPayload, null);
      }
    },
    onAdd: (target) => {
      const { editing } = this.state;

      this.forceUpdate();
      if (!editing) {
        this.changeEditing(true);
      }
      if (target.id === "cropRect") {
        return;
      }
      if (target.type === ACTIVE_SELECTION || target.id === "addText") {
        this.canvasHandlers.onSelect(null);
        return;
      }

      this.canvasHandlers.onUpdate(
        target,
        target.toJSON(
          this.canvasRef.handler.propertiesToInclude,
          this.canvasRef.handler.propertiesToExclude
        ),
        {
          update_source: UpdateSourceTypes.SYSTEM,
        }
      );
    },
    onSelect: (target) => {
      const { selectedItem } = this.state;
      if (target) {
        if (
          target.id &&
          target.id !== "workarea" &&
          target.type !== ACTIVE_SELECTION
        ) {
          if (selectedItem && target.id === selectedItem.id) {
            return;
          }
          this.props.setActiveLayer(null, null, null, null);

          if (target && target.animation) {
            this.canvasRef.handler.animationHandler.stop(
              target.id,
              target.animation,
              true,
              false
            );
          }

          this.stopPlayingAllVideo();

          this.setState({
            selectedItem: target,
          });

          this.canvasHandlers.onActiveLayer(target);
          return;
        } else if (
          target.type === ACTIVE_SELECTION ||
          target.type === "group"
        ) {
          const selectedIds = [];
          target._objects.forEach((objectInGroup) => {
            selectedIds.push(objectInGroup.id);
          });
          batch(() => {
            this.props.setClonedItems(null);
            this.props.setGroupSelection(
              target.type === ACTIVE_SELECTION ? "selection" : target.type,
              selectedIds
            );
            this.canvasHandlers.onActiveLayer(null);
          });

          return;
        }
      }

      this.setState({
        selectedItem: null,
      });
      batch(() => {
        this.props.setGroupSelection(null, null);
        this.canvasHandlers.onActiveLayer(null);
      });
    },
    onRemove: (target) => {
      const { activePage } = this.props;
      const { editing } = this.state;
      if (!editing) {
        this.changeEditing(true);
      }
      if (target?.type === ACTIVE_SELECTION) {
        const selectedIds = [];
        target._objects.forEach((objectInGroup) => {
          selectedIds.push(objectInGroup.id);
        });
        this.props.wsDeleteLayers(selectedIds, activePage.id);
      } else if (!target && activePage.isSelected) {
        if (!activePage.id) {
          return;
        }

        this.props.wsDeletePage(activePage.id);
      } else {
        this.canvasHandlers.onActiveLayer(null);
        this.props.wsDeleteLayers([target?.id], activePage.id);
      }
    },
    onModified: debounce(this.onModifiedLayer, 300),
    onModifiedNoDebounce: this.onModifiedLayer,
    onChange: (selectedItem, changedValues, allValues) => {
      const { editing } = this.state;
      if (!editing) {
        this.changeEditing(true);
      }
      const changedKey = Object.keys(changedValues)[0];
      const changedValue = changedValues[changedKey];

      if (changedKey === "width" || changedKey === "height") {
        this.canvasRef.handler.scaleToResize(allValues.width, allValues.height);
        return;
      }
      if (changedKey === "angle") {
        this.canvasRef.handler.rotate(allValues.angle);
        return;
      }
      if (changedKey === "locked") {
        this.canvasRef.handler.setObject({
          lockMovementX: changedValue,
          lockMovementY: changedValue,
          hasControls: !changedValue,
          hoverCursor: changedValue ? "pointer" : "move",
          editable: !changedValue,
          locked: changedValue,
        });
        return;
      }
      if (
        changedKey === "file" ||
        changedKey === "src" ||
        changedKey === "code"
      ) {
        if (selectedItem.type === "image") {
          this.canvasRef.handler.setImageById(selectedItem.id, changedValue);
        } else if (selectedItem.superType === "element") {
          this.canvasRef.handler.elementHandler.setById(
            selectedItem.id,
            changedValue
          );
        }
        return;
      }
      if (changedKey === "link") {
        const link = Object.assign({}, defaultOption.link, allValues.link);
        this.canvasRef.handler.set(changedKey, link);
        return;
      }
      if (changedKey === "tooltip") {
        const tooltip = Object.assign(
          {},
          defaultOption.tooltip,
          allValues.tooltip
        );
        this.canvasRef.handler.set(changedKey, tooltip);
        return;
      }
      if (changedKey === "animation") {
        const animation = Object.assign(
          {},
          defaultOption.animation,
          allValues.animation
        );
        this.canvasRef.handler.set(changedKey, animation);
        return;
      }
      if (changedKey === "icon") {
        const { unicode, styles } = changedValue[Object.keys(changedValue)[0]];
        const uni = parseInt(unicode, 16);
        if (styles[0] === "brands") {
          this.canvasRef.handler.set("fontFamily", "Font Awesome 5 Brands");
        } else if (styles[0] === "regular") {
          this.canvasRef.handler.set("fontFamily", "Font Awesome 5 Regular");
        } else {
          this.canvasRef.handler.set("fontFamily", "Font Awesome 5 Free");
        }
        this.canvasRef.handler.set("text", String.fromCodePoint(uni));
        this.canvasRef.handler.set("icon", changedValue);
        return;
      }
      if (changedKey === "shadow") {
        if (allValues.shadow.enabled) {
          if ("blur" in allValues.shadow) {
            this.canvasRef.handler.setShadow(allValues.shadow);
          } else {
            this.canvasRef.handler.setShadow({
              enabled: true,
              blur: 15,
              offsetX: 10,
              offsetY: 10,
            });
          }
        } else {
          this.canvasRef.handler.setShadow(null);
        }
        return;
      }
      if (changedKey === "fontWeight") {
        this.canvasRef.handler.set(
          changedKey,
          changedValue ? "bold" : "normal"
        );
        return;
      }
      if (changedKey === "fontStyle") {
        this.canvasRef.handler.set(
          changedKey,
          changedValue ? "italic" : "normal"
        );
        return;
      }
      if (changedKey === "textAlign") {
        this.canvasRef.handler.set(changedKey, Object.keys(changedValue)[0]);
        return;
      }
      if (changedKey === "trigger") {
        const trigger = Object.assign(
          {},
          defaultOption.trigger,
          allValues.trigger
        );
        this.canvasRef.handler.set(changedKey, trigger);
      }
    },
    onChangeWokarea: (changedKey, changedValue, allValues) => {
      if (changedKey === "layout") {
        this.canvasRef.handler.workareaHandler.setLayout(changedValue);
        return;
      }
      if (changedKey === "file" || changedKey === "src") {
        this.canvasRef.handler.workareaHandler.setImage(changedValue);
        return;
      }
      if (changedKey === "width" || changedKey === "height") {
        this.canvasRef.handler.originScaleToResize(
          this.canvasRef.handler.workarea,
          allValues.width,
          allValues.height
        );
        this.canvasRef.canvas.centerObject(this.canvasRef.handler.workarea);
        return;
      }
      this.canvasRef.handler.workarea.set(changedKey, changedValue);
      this.canvasRef.canvas.requestRenderAll();
    },
    onClick: (canvas, target) => {
      const { link } = target;
      if (link.state === "current") {
        document.location.href = link.url;
        return;
      }
      openUrl(link.url);
    },
    onContext: (ref, event, target) => {
      return (
        <TldrContextMenu
          target={target}
          canvasRef={this.canvasRef}
          parentProps={this.props}
          signal={this.signal}
        />
      );
    },
    onTransaction: () => {
      this.forceUpdate();
    },
    onTextFormatingChange: debounce((target, message) => {
      const { editing } = this.state;
      this.forceUpdate();
      if (!editing) {
        this.changeEditing(true);
      }
      let objectPayload = target.toJSON(
        this.canvasRef.handler.propertiesToInclude
      );
      this.props.setElementFormat(objectPayload);
      this.canvasHandlers.onUpdate(target, objectPayload, message);
    }, 500),
    onVideoPlayingStatusChange: (isPlaying) => {
      this.props.setVideoPlayingStatus(isPlaying);
    },
    onCopy: () => {
      const { activePage, activeElement, activeSelection } = this.props.editor;
      const { t } = this.props;

      if (activeSelection.mime === "selection") {
        // clone activeSelection
        this.canvasRef.handler.copyToClipboard(
          activeSelection.selectedElements
        );
        showToast({
          description: t("story.copied_msg", {
            ns: "common",
            comboKey: comboKey1,
          }),
          title: t("success", { ns: "common" }),
          status: "success",
        });
      } else if (!activePage.isSelected) {
        // Clone selected layer
        this.canvasRef.handler.copyToClipboard([activeElement.id]);
        showToast({
          description: t("story.copied_msg", {
            ns: "common",
            comboKey: comboKey1,
          }),
          title: t("success", { ns: "common" }),
          status: "success",
        });
      }
    },
    onPaste: (acceptedFiles, isInternalElementCopied) => {
      const { activePage } = this.props.editor;
      const { t } = this.props;

      if (typeof acceptedFiles === "object" && this.isCut) {
        const copiedLayerIds = acceptedFiles?.elementIds;
        const sourcePageId = acceptedFiles?.sourcePageId;
        const destinationPageId = activePage.id;

        // clone the layers
        this.props.wsCloneLayers(copiedLayerIds, destinationPageId);
        // then remove the layers
        this.props.wsDeleteLayers(copiedLayerIds, sourcePageId);

        this.isCut = false;
      }

      if (
        activePage.id &&
        Array.isArray(acceptedFiles) &&
        isInternalElementCopied
      ) {
        this.props.wsCloneLayers(acceptedFiles, activePage.id);
      } else if (
        acceptedFiles &&
        typeof acceptedFiles === "object" &&
        !isInternalElementCopied
      ) {
        this.upload(acceptedFiles);
      } else if (
        acceptedFiles &&
        typeof acceptedFiles === "string" &&
        !isInternalElementCopied
      ) {
        if (!isURL(acceptedFiles)) {
          return;
        }

        if (
          isURL(acceptedFiles) &&
          !endsWithAny(PASTED_URL_SUFFIXES, acceptedFiles)
        ) {
          showToast({
            description: t("errors.format_not_supported", { ns: "common" }),
            title: t("errors.invalid_url", { ns: "common" }),
            status: "error",
          });
          return;
        } else {
          if (endsWithAny(IMAGE_URL_SUFFIXES, acceptedFiles)) {
            const item = {
              mime: "image",
              payload: {
                name: "New Image",
                src: acceptedFiles,
                type: "image",
                identifier: acceptedFiles,
                app_id: ImageAppSources.COPY_PASTE,
              },
              content: {
                url: acceptedFiles,
                meta: {},
              },
              page: activePage.id,
            };
            this.addToArtBoard(item);
          } else if (endsWithAny(MUSIC_URL_SUFFIXES, acceptedFiles)) {
            const { story } = this.props;

            const data = { ...defaultMusicPayload };

            const payload = {
              ...data,
              title: "New Music",
              src: acceptedFiles,
              action: "add",
            };

            getMediaDurationFromFile(acceptedFiles).then((duration) => {
              payload.duration = duration;
              payload.source = "custom";
              payload.source_url = acceptedFiles;

              batch(() => {
                if (story?.payload?.payload?.music) {
                  this.props.wsUpdateMusic({ music: payload });
                } else {
                  this.props.wsAddMusic({ music: payload });
                }
                this.props.closeSlider(); // close slider once music added
                this.props.updateStoryMusic(payload);
              });
            });
          }
        }
      }
    },
    onSelectTopLayer: () => {
      const currentPageLayers = this.canvasRef.handler.getObjects();
      const layerId = currentPageLayers[currentPageLayers.length - 1].id;

      this.canvasRef.handler.searchAndSelect(layerId);
    },
    onSelectBottomLayer: () => {
      const currentPageLayers = this.canvasRef.handler.getObjects();
      const layerId = currentPageLayers[0].id;

      this.canvasRef.handler.searchAndSelect(layerId);
    },
    onUndo: () => {
      this.props.wsUndo();
    },
    onRedo: () => {
      this.props.wsRedo();
    },
    onGroup: (group, updatedLayers) => {
      const { activePage, activeSelection } = this.props.editor;
      batch(() => {
        this.props.setGroupSelection(null, null);
        this.props.wsGroup(
          activePage.id,
          updatedLayers,
          activeSelection.selectedElements
        );
        this.props.setActiveLayer(
          group,
          getMIMETypeFromFabricObject(updatedLayers.type),
          null,
          null
        );
      });
    },
    onUngroup: (group, updatedLayers) => {
      batch(() => {
        this.props.setGroupSelection(null, null);
        this.props.wsUnGroup(group, updatedLayers);
        this.props.setActiveLayer(null, null, null, null);
      });
    },
    onClone: () => {
      const { activePage, activeElement, activeSelection } = this.props.editor;
      const { pagestore, subscription } = this.props;

      if (activeSelection.mime === "selection") {
        // close selected layer
        this.props.wsCloneLayers(
          activeSelection.selectedElements,
          activePage.id
        );
      } else if (activePage.isSelected) {
        // Clone selected page
        const isAvailable = checkArtboardLimit(pagestore, subscription);
        if (isAvailable) this.props.wsClonePage(activePage.id);
      } else {
        // Clone selected/active layer
        this.props.wsCloneLayers([activeElement.id], activePage.id);
      }
    },
    onExportAsJPEG: () => {
      const { story } = this.props;

      const dataURL = this.canvasRef.handler.getArtBoardAsDataURL({
        format: "jpeg",
        quality: 1,
        multiplier: 1,
        name: `${story.payload.title}`,
      });

      if (!dataURL) {
        showToast({
          description: EXPORT_IMAGE_ERROR_PAYLOAD.message,
          title: EXPORT_IMAGE_ERROR_PAYLOAD.heading,
          status:
            EXPORT_IMAGE_ERROR_PAYLOAD.type === "error" ? "error" : "success",
        });

        return;
      }

      this.canvasRef.handler.saveDataURLToFile(dataURL, {
        format: "jpeg",
        name: `${story.payload.title}`,
      });
    },
    onPrevArtboardSelection: () => {
      const { activePage, pagestore } = this.props;
      let currentArtBoardId = activePage.id;
      let currentArtBoardIndex = findIndex(pagestore.pageIds, (id) => {
        return id === currentArtBoardId;
      });
      let pageIndex = findIndex(pagestore.pageIds, (pageId) => {
        return pageId === currentArtBoardId;
      });

      if (pageIndex === 0) {
        return;
      }

      if (currentArtBoardIndex > -1) {
        this.props.setActivePage(
          pagestore.pageIds[currentArtBoardIndex - 1],
          currentArtBoardIndex - 1,
          true
        );
      }
    },
    onNextArtboardSelection: () => {
      const { activePage, pagestore } = this.props;
      let currentArtBoardId = activePage.id;
      let currentArtBoardIndex = findIndex(pagestore.pageIds, (id) => {
        return id === currentArtBoardId;
      });
      let pageIndex = findIndex(pagestore.pageIds, (pageId) => {
        return pageId === currentArtBoardId;
      });

      let totalArtBoard = pagestore.pageIds.length;
      if (pageIndex + 1 === totalArtBoard) {
        return;
      }
      if (currentArtBoardIndex < pagestore.pageIds.length) {
        this.props.setActivePage(
          pagestore.pageIds[currentArtBoardIndex + 1],
          currentArtBoardIndex + 1,
          true
        );
      }
    },
    onGrabModeEnable: () => {
      if (this.canvasRef.handler.cropHandler.cropRect) {
        this.canvasRef.handler.cropHandler.cancel(false);
      }
      if (this.canvasRef.handler.clipHandler.clipRect) {
        this.canvasRef.handler.clipHandler.cancel(false);
      }

      this.canvasRef.handler.interactionHandler.grab();
    },
    onGrabModeDisable: () => {
      this.canvasRef.handler.interactionHandler.selection();
    },
    onSelectAllLayers: () => {
      if (this.canvasRef.handler.selectAll) {
        this.canvasRef.handler.selectAll();
      }
    },
    onCut: () => {
      const { activePage, activeElement, activeSelection } = this.props.editor;
      const { t } = this.props;

      var dataToBeCopied = {
        sourcePageId: activePage.id,
      };

      if (activeSelection.mime === "selection") {
        Object.assign(dataToBeCopied, {
          elementIds: activeSelection.selectedElements,
        });
      } else if (activePage.isSelected) {
        return;
      } else {
        Object.assign(dataToBeCopied, {
          elementIds: [activeElement.id],
        });
      }

      this.canvasRef.handler.copyToClipboard(dataToBeCopied);
      showToast({
        description: t("story.cut_msg", {
          ns: "common",
          comboKey: comboKey1,
        }),
        title: t("success", { ns: "common" }),
        status: "success",
      });
      this.isCut = true;
    },
  };

  stopPlayingAllVideo = () => {
    let allVideosOnCanvas = this.canvasRef.handler.objects.filter(
      (object) => object.type === "video"
    );
    allVideosOnCanvas.forEach((videoObj) => {
      this.canvasRef.handler.stopRequestAnimFrame();
      videoObj.stop();
    });
    this.props.setVideoPlayingStatus(false);
  };

  changeEditing = (editing) => {
    this.setState({
      editing,
    });
  };

  componentWillUnmount() {
    this.props.resetFonts();
    this.props.wsDisconnect();
    this.signal.cancel("The user aborted a request.");
    this.timers.forEach((timer) => {
      clearInterval(timer);
    });
  }

  onSliderContainerMouseMove = (e) => {
    e.persist();
    // this.thorttledTrackMousePointer(e);
  };

  trackMousePointer = (e) => {
    let pageAreaOffset = this.pageAreaRef.getBoundingClientRect();

    let pointer = {
      x: Number.parseFloat(
        ((e.nativeEvent.clientX - pageAreaOffset.left) / pageAreaOffset.width) *
          100
      ).toFixed(2),
      y: Number.parseFloat(
        ((e.nativeEvent.clientY - pageAreaOffset.top) / pageAreaOffset.height) *
          100
      ).toFixed(2),
    };

    this.props.wsBroadcast({
      type: REMOTE_COLLOBORATION_BROADCAST_MOUSE_POINTER,
      data: {
        pointer: pointer,
        user: this.props.auth.payload.user,
      },
    });
  };

  showRemoteMousePointers = () => {
    let users = this.props.mousepointerstore.users;
    let mousePointers = [];
    for (let key in users) {
      if (!users.hasOwnProperty(key)) continue;

      let pointerPosition = users[key].pointer;

      if (pointerPosition) {
        mousePointers.push(
          <StyledPointer
            color={this.getColor(users[key].user.pk)}
            top={pointerPosition.y}
            left={pointerPosition.x}
          >
            <TldrPointer />
            <div>
              <StyledUserLabel>
                {`${users[key].user.first_name} ${users[key].user.last_name}`}
              </StyledUserLabel>
            </div>
          </StyledPointer>
        );
      }
    }
    return mousePointers;
  };

  getColor = (pk) => {
    const usersOnline = this.props.session.users;
    let color = "";

    usersOnline.forEach((user) => {
      if (user.pk === pk) {
        color += user.colorApplied;
      }
    });
    return color;
  };

  getArtBoardSize = (artboardHeight, artboardWidth) => {
    let editorAreaHeight = this.editorAreaRef.current
      ? this.editorAreaRef.current.clientHeight
      : 576;
    let editorAreaWidth = this.editorAreaRef.current
      ? this.editorAreaRef.current.clientWidth
      : 1024;
    let artBoardAspectRatio = artboardWidth / artboardHeight;

    let artBoardPreLoaderHeightPercentage = 60;
    let artBoardPreLoaderWidth =
      (artBoardAspectRatio *
        editorAreaHeight *
        artBoardPreLoaderHeightPercentage) /
      100;

    let artBoardPreLoaderWidthPercentage =
      (100 * artBoardPreLoaderWidth) / editorAreaWidth;

    return {
      heightPercentage: artBoardPreLoaderHeightPercentage,
      widthPercentage: artBoardPreLoaderWidthPercentage,
    };
  };

  onMenuItemClick = (item) => {
    if (!item?.extraData?.panel) {
      return;
    }
    this.openPanel(item?.extraData?.panel);
  };

  getActivePageDuration = () => {
    const {
      editor: { activePage: { id } = {} },
      pagestore: { pages = {} } = {},
    } = this.props;
    const page = pages[id];
    if (page) {
      return page?.payload?.animation?.duration ?? DEFAULT_ARTBOARD_DURATION;
    }
    return DEFAULT_ARTBOARD_DURATION;
  };

  resetTrimmingData = () => {
    this.setState({
      mediaTrimmingData: {
        show: false,
        data: null,
        maxTrim: null,
      },
    });
  };

  onSubmitTrimMedia = (startTime, endTime) => {
    const {
      mediaTrimmingData: { data },
    } = this.state;
    const updatedVideoData = {
      ...data,
      payload: {
        ...data.payload,
        startTime: startTime,
        endTime: endTime,
      },
    };
    this.resetTrimmingData();
    this.addToArtBoard(updatedVideoData);
  };

  getSharedItemOrgUser = (story) => {
    const { auth } = this.props;
    const { id: storyId } = story;
    const { payload: authPayload } = auth;
    const { user } = authPayload;
    const { pk: userId } = user;
    if (!storyId) {
      return;
    }
    return axios
      .get(format(SHARED_ITEM_USER_ENDPOINT, storyId, userId))
      .then((response) => {
        const userDetailInfo = response.data;
        if (!isEmpty(userDetailInfo)) {
          this.props.setRBStoryPermissionCheck(userDetailInfo);
        }
      });
  };

  onHotkeysToggleGlobalSearch = (e) => {
    e.preventDefault();

    const { isSearchShowing } = this.props;
    const showCommandKContent = isSearchShowing === "open";
    if (showCommandKContent) {
      this.props.hideCommandKSearch();
    } else {
      this.props.showCommandKSearch();
    }
  };

  onHotkeysUndo = (e) => {
    e.preventDefault();
    this.canvasHandlers.onUndo();
  };

  onHotkeysRedo = (e) => {
    e.preventDefault();
    this.canvasHandlers.onRedo();
  };

  onHotkeysOpenSidebarPanel = (e, panel) => {
    e.preventDefault();
    if (!panel) {
      return;
    }

    this.props.openSlider(panel);
  };

  onHotkeysCloseSidebarPanel = (e) => {
    e.preventDefault();
    this.props.closeSlider();
  };

  onHotkeysZoomIn = (e) => {
    e.preventDefault();
    this.canvasRef.handler.zoomHandler.zoomIn();
  };

  onHotkeysZoomOut = (e) => {
    e.preventDefault();
    this.canvasRef.handler.zoomHandler.zoomOut();
  };

  onHotkeysZoomOneToOne = (e) => {
    e.preventDefault();
    this.canvasRef.handler.zoomHandler.zoomOneToOne();
  };

  onHotkeysZoomToFit = (e) => {
    e.preventDefault();
    this.canvasRef.handler.zoomHandler.zoomToFit();
  };

  onHotkeysClone = (e) => {
    e.preventDefault();
    this.canvasHandlers.onClone();
  };

  onHotkeysDelete = (e) => {
    e.preventDefault();

    if (!this.canvasRef.handler) return;

    const activeObject = this.canvasRef.handler.canvas.getActiveObject();
    this.canvasHandlers.onRemove(activeObject);
  };

  onHotkeysPrevArtboardSelection = (e) => {
    e.preventDefault();
    this.canvasHandlers.onPrevArtboardSelection();
  };

  onHotkeysNextArtboardSelection = (e) => {
    e.preventDefault();
    this.canvasHandlers.onNextArtboardSelection();
  };

  onHotkeysCopy = (e) => {
    e.preventDefault();
    this.canvasHandlers.onCopy();
  };

  onHotkeysPaste = (e) => {
    e.preventDefault();
    this.canvasRef.handler.paste();
  };

  onHotkeysLockLayer = (e) => {
    e.preventDefault();
    const activeObject = this.canvasRef.handler.canvas.getActiveObject();
    if (!activeObject || activeObject.type === "activeSelection") {
      return;
    }

    if (activeObject.selectable) {
      this.canvasRef.handler.lockLayer();
    }
  };

  onHotkeysGroup = (e) => {
    e.preventDefault();
    this.canvasRef.handler.toGroup();
  };

  onHotkeysUngroup = (e) => {
    e.preventDefault();
    this.canvasRef.handler.toActiveSelection();
  };

  onHotkeysSelectTopLayer = (e) => {
    e.preventDefault();
    this.canvasHandlers.onSelectTopLayer();
  };

  onHotkeysSelectBottomLayer = (e) => {
    e.preventDefault();
    this.canvasHandlers.onSelectBottomLayer();
  };

  onHotkeysMoveLayerOneUnit = (e) => {
    e.preventDefault();
    const offset = 1;

    this.handleArrowKeys(e, offset);
  };

  onHotkeysMoveLayerTenUnits = (e) => {
    e.preventDefault();
    const offset = 10;

    this.handleArrowKeys(e, offset);
  };

  onHotkeysMoveLayerHundredUnits = (e) => {
    e.preventDefault();
    const offset = 100;

    this.handleArrowKeys(e, offset);
  };

  handleArrowKeys = (e, offset) => {
    const activeObject = this.canvasRef.handler.canvas.getActiveObject();

    switch (e.key) {
      case keyCode.ARROW_LEFT:
        if (!activeObject || activeObject.id === "workarea") {
          this.onHotkeysPrevArtboardSelection(e);
          return;
        }
        if (activeObject) {
          activeObject.set("left", activeObject.left - offset);
          activeObject.setCoords();
          this.canvasRef.handler.canvas.renderAll();
        }
        break;
      case keyCode.ARROW_UP:
        if (activeObject) {
          activeObject.set("top", activeObject.top - offset);
          activeObject.setCoords();
          this.canvasRef.handler.canvas.renderAll();
        }
        break;
      case keyCode.ARROW_RIGHT:
        if (!activeObject || activeObject.id === "workarea") {
          this.onHotkeysNextArtboardSelection(e);
          return false;
        }
        if (activeObject) {
          activeObject.set("left", activeObject.left + offset);
          activeObject.setCoords();
          this.canvasRef.handler.canvas.renderAll();
        }
        break;
      case keyCode.ARROW_DOWN:
        if (activeObject) {
          activeObject.set("top", activeObject.top + offset);
          activeObject.setCoords();
          this.canvasRef.handler.canvas.renderAll();
        }
        break;
      default:
        break;
    }

    this.canvasRef.handler.canvas.fire("object:modified", {
      target: activeObject,
    });
  };

  onHotkeysBold = (e) => {
    e.preventDefault();
    const activeObject = this.canvasRef.handler.canvas.getActiveObject();

    if (FABRIC_TEXT_TYPES.includes(activeObject?.type)) {
      const currentFontWeight = activeObject.fontWeight;
      const fontWeight =
        currentFontWeight >= FONT_BOLD_WEIGHT
          ? FONT_REGULAR_WEIGHT
          : FONT_BOLD_WEIGHT;
      this.canvasRef.handler.textHandler.bold(fontWeight);
    }
  };

  onHotkeysItalic = (e) => {
    e.preventDefault();
    const activeObject = this.canvasRef.handler.canvas.getActiveObject();

    if (FABRIC_TEXT_TYPES.includes(activeObject?.type)) {
      const currentFontStyle = activeObject.fontStyle;
      const fontStyle = currentFontStyle === "italic" ? "normal" : "italic";
      this.canvasRef.handler.textHandler.italic(fontStyle);
    }
  };

  onHotkeysUnderline = (e) => {
    e.preventDefault();
    const activeObject = this.canvasRef.handler.canvas.getActiveObject();

    if (FABRIC_TEXT_TYPES.includes(activeObject?.type)) {
      const currentUnderline = activeObject.underline;
      this.canvasRef.handler.textHandler.underline(!currentUnderline);
    }
  };

  onHotkeysStrikethrough = (e) => {
    e.preventDefault();
    const activeObject = this.canvasRef.handler.canvas.getActiveObject();

    if (FABRIC_TEXT_TYPES.includes(activeObject?.type)) {
      const currentLinethrough = activeObject.linethrough;
      this.canvasRef.handler.textHandler.strike(!currentLinethrough);
    }
  };

  onHotkeysExportAsJPEG = (e) => {
    e.preventDefault();
    this.canvasHandlers.onExportAsJPEG();
  };

  onHotkeysGrabModeEnable = (e) => {
    e.preventDefault();
    this.canvasHandlers.onGrabModeEnable();
  };

  onHotkeysGrabModeDisable = (e) => {
    e.preventDefault();
    this.canvasHandlers.onGrabModeDisable();
  };

  onHotkeysSelectAllLayers = (e) => {
    e.preventDefault();
    this.canvasHandlers.onSelectAllLayers();
  };

  onHotkeysCut = (e) => {
    e.preventDefault();
    this.canvasHandlers.onCut();
  };

  onHotkeysLayerOrderChange = (e, order) => {
    e.preventDefault();

    const { editor, layerstore, pagestore } = this.props;
    const { pages } = pagestore;
    const { layers } = layerstore;
    const { activeElement, activePage } = editor;
    const { id: activePageId } = activePage;
    const { id: activeElementId } = activeElement;
    const totalLayersInPage = pages[activePageId].layers.length - 1;
    const selectedLayer = layers[activeElementId];

    if (!activeElementId) {
      return;
    }

    if (
      (order === LAYER_ORDER_BRING_TO_FRONT ||
        order === LAYER_ORDER_BRING_FORWARD) &&
      selectedLayer?.order === totalLayersInPage
    ) {
      return;
    } else if (
      (order === LAYER_ORDER_SEND_BACKWARD ||
        order === LAYER_ORDER_SEND_TO_BACK) &&
      selectedLayer?.order === 0
    ) {
      return;
    }

    this.canvasRef.handler.move(order);
    this.props.wsMoveLayer(order, activeElement.id);
  };
}

StoryDetailsPage.propTypes = {
  editor: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fonts: state.app.fonts,
  mousepointerstore: state.mousepointerstore,
  auth: state.auth,
  pagestore: state.pagestore,
  layerstore: state.layerstore,
  session: state.session,
  activePage: state.editor.activePage,
  editor: state.editor,
  story: state.story,
  sidebarSlider: state.sidebarSlider,
  isSearchShowing: state.commandK.isSearchShowing,
  actions: state.actions,
  rightsidebar: state.rightsidebar,
  bottomPanel: state.bottomPanel,
  isMobileView: state.app.isMobileView,
  subscription: state.subscription,
  brandkits: state.brandKit.brandkitPayload,
});

const mapDispatchToProps = (dispatch) => ({
  fetchCommentCount: (pageId) => dispatch(fetchCommentsCount(pageId)),
  setActiveLayer: (elementId, elementType, elementFormat, elementParentId) =>
    dispatch(
      setActiveLayer(elementId, elementType, elementFormat, elementParentId)
    ),
  fetchStoryPages: (storyId, pageId, props) =>
    dispatch(fetchStoryPages(storyId, pageId, props)),
  fetchStoryDetail: (storyId, cancelToken, props) =>
    dispatch(fetchStoryDetail(storyId, cancelToken, props)),
  wsConnect: (url) => dispatch(wsConnect(url)),
  wsDisconnect: () => dispatch(wsDisconnect()),
  wsBroadcast: (payload) => dispatch(wsBroadcast(payload)),
  fetchFonts: (props, cancelToken) => dispatch(fetchFonts(props, cancelToken)),
  fetchAllFonts: (props, cancelToken, page) =>
    dispatch(fetchAllFonts(props, cancelToken, page)),
  fetchStoryFonts: (storyId, cancelToken, props) =>
    dispatch(fetchStoryFonts(storyId, cancelToken, props)),
  wsAddLayer: (pageId, message) => dispatch(wsAddLayer(pageId, message)),
  wsDeleteLayers: (layerIds, pageId) =>
    dispatch(wsDeleteLayers(layerIds, pageId)),
  wsUpdateLayers: (layers, pageId) => dispatch(wsUpdateLayers(layers, pageId)),
  setActivePage: (pageId, pageIndex, isSelected) =>
    dispatch(setActivePage(pageId, pageIndex, isSelected)),
  switchWorkspace: (workspaceId, token) =>
    dispatch(switchWorkspace(workspaceId, token)),
  wsUpdateLayer: (payload) => dispatch(wsUpdateLayer(payload)),
  setElementFormat: (format) => dispatch(setElementFormat(format)),
  closeSlider: () => dispatch(closeSlider()),
  wsUpdatePage: (payload) => dispatch(wsUpdatePage(payload)),
  setGroupSelection: (objectType, selectedIds) =>
    dispatch(setGroupSelection(objectType, selectedIds)),
  wsAddPage: () => dispatch(wsAddPage()),
  wsStatusMessage: (message) => dispatch(wsStatusMessage(message)),
  setClonedItems: (ids) => dispatch(setClonedItems(ids)),
  uploadImageAndAddLayer: (file, props, signalToken) =>
    dispatch(uploadImageAndAddLayer(file, props, signalToken)),
  uploadFile: (file, props, signalToken, callback) =>
    dispatch(uploadFile(file, props, signalToken, callback)),
  checkAssetStatus: (assetId, props, signalToken) =>
    dispatch(checkAssetStatus(assetId, props, signalToken)),
  openSlider: (sliderPanelType) => dispatch(openSlider(sliderPanelType)),
  wsMoveLayer: (action, payload) => dispatch(wsMoveLayer(action, payload)),
  wsCopyFromTemplate: (pageId, templateId) =>
    dispatch(wsCopyFromTemplate(pageId, templateId)),
  setCrop: (isEnable) => dispatch(setCrop(isEnable)),
  closeBottomPanel: () => dispatch(closeBottomPanel()),
  openBottomPanel: () => dispatch(openBottomPanel()),
  setVideoPlayingStatus: (isPlaying) =>
    dispatch(setVideoPlayingStatus(isPlaying)),
  setCounter: (counter) => dispatch(setCounter(counter)),
  fetchBrandKits: () => dispatch(fetchBrandKits()),
  wsDeletePage: (pageId) => dispatch(wsDeletePage(pageId)),
  showCommandKSearch: () => dispatch(showCommandKSearch()),
  hideCommandKSearch: () => dispatch(hideCommandKSearch()),
  wsUndo: () => dispatch(wsUndo()),
  wsRedo: () => dispatch(wsRedo()),
  wsGroup: (pageId, group, layers) => dispatch(wsGroup(pageId, group, layers)),
  wsUnGroup: (group, layerId) => dispatch(wsUnGroup(group, layerId)),
  wsCloneLayers: (layerIds, pageId) =>
    dispatch(wsCloneLayers(layerIds, pageId)),
  wsClonePage: (pageId) => dispatch(wsClonePage(pageId)),
  syncWorkspaces: () => dispatch(syncWorkspaces()),
  openAdvancedSettings: (panel, selectedTab) =>
    dispatch(openAdvancedSettings(panel, selectedTab)),
  getSubscription: () => dispatch(getSubscription()),
  wsAddMusic: (payload) => dispatch(wsAddMusic(payload)),
  wsUpdateMusic: (payload) => dispatch(wsUpdateMusic(payload)),
  updateStoryMusic: (musicData) => dispatch(updateStoryMusic(musicData)),
  wsSetAsBackground: (pageId, layerId) =>
    dispatch(wsSetAsBackground(pageId, layerId)),
  setRBStoryPermissionCheck: (userDetail) =>
    dispatch(setRBStoryPermissionCheck(userDetail)),
  uploadFontFile: (orgId, file, metaInfo, brandKitId) =>
    dispatch(uploadFontFile(orgId, file, metaInfo, brandKitId)),
  resetFonts: () => dispatch(resetFonts()),
});

export default withTranslation(["common", "fontlist"])(
  connect(mapStateToProps, mapDispatchToProps)(StoryDetailsPage)
);
